
<template>
    <div id="google-map-wrapper">

        <google-map-markers :map="map"></google-map-markers>

        <div id="google-map"></div>

    </div>
</template>


<script>
    export default {

        props: {
            apiKey: {type: String, required: false},
            region: String,
            language: String,
        },

        data() {
            return{
                map: {},
                center: { lat: 40.428768, lng: -3.687037 },
            }
        },
        mounted() {
            GoogleMapsLoader.KEY = this.apiKey;
            GoogleMapsLoader.LIBRARIES = ['places','drawing'];
            GoogleMapsLoader.LANGUAGE = this.language;
            GoogleMapsLoader.REGION = this.region;

            GoogleMapsLoader.load( (google) => {
                this.initializeMap(google);
            });
        },

        methods: {

            initializeMap: function (google) {

                let customStyles = [
                    {
                        featureType: 'poi',
                        stylers: [
                            { visibility: 'off' }
                        ]
                    },
                    {
                        featureType: 'road.local',
                        elementType: 'geometry',
                        stylers: [
                            { color: '#FFFFFF' }
                        ]
                    },
                    {
                        featureType: 'landscape',
                        stylers: [
                            { color: '#F0F0F0' }
                        ]
                    },
                ];

                this.map = new google.maps.Map ( document.getElementById( 'google-map' ), {
                    center: this.center,
                    zoom: 14,
                    minZoom: 5,
                    tilt: 0,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: customStyles,
                    clickableIcons: false,
                    streetViewControl: false,
                    disableDefaultUI: true,
                    mapTypeControl: false,
                });

                this.initializeBus(google);
            },

            initializeBus: function ( google ) {

                bus.$emit( 'map-initialized', google );

            },
        }
    }

</script>

<style lang="scss">
    @import "./../../sass/variables";

    #google-map{
        height: 34.5rem;

        @media only screen and (max-device-width: 36em) {
            height: 29rem;
        }

    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/GoogleMap.vue